var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scoreInquiry-wrap"},[_c('Nav',{attrs:{"pt":_vm.isIndex}}),_c('div',{staticClass:"contents"}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }